var _path, _circle, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaso2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.58,
    d: "M47.25 72.5879C61.2737 72.5879 72.6421 61.2154 72.6421 47.1867C72.6421 33.158 61.2737 21.7855 47.25 21.7855C33.2263 21.7855 21.8579 33.158 21.8579 47.1867C21.8579 61.2154 33.2263 72.5879 47.25 72.5879Z",
    fill: "url(#paint0_radial_1569_7305)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9199 58.4724C40.9199 58.4724 39.4028 58.1643 38.8552 57.6158C38.3076 57.0674 38 56.3235 38 55.5478V40.9246C38 40.149 38.3076 39.4051 38.8552 38.8566C39.4028 38.3081 40.1455 38 40.9199 38H52.5997C53.3742 38 54.1169 38.3081 54.6645 38.8566C55.212 39.4051 55.5197 40.149 55.5197 40.9246V55.5478C55.5197 56.3235 55.212 57.0674 54.6645 57.6158C54.1169 58.1643 53.3742 58.4724 52.5997 58.4724M42.3799 45.3116H49.6798M42.3799 48.2362H51.1398M42.3799 51.1609H46.7598",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.7402,
    cy: 59.7402,
    r: 3.24016,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0394 58.4724L52.5669 58.4724",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 61C44.4441 61 44.3972 60.9815 44.3595 60.9445C44.3216 60.9077 44.3026 60.862 44.3026 60.8074V58.6549L43.3405 59.5939C43.301 59.6324 43.2541 59.6517 43.1997 59.6517C43.1455 59.6517 43.0987 59.6324 43.0592 59.5939C43.0197 59.5554 43 59.5104 43 59.4591C43 59.4077 43.0197 59.3628 43.0592 59.3242L44.3618 58.053C44.3816 58.0337 44.403 58.02 44.426 58.0119C44.449 58.004 44.4737 58 44.5 58C44.5263 58 44.5518 58.004 44.5766 58.0119C44.6012 58.02 44.6217 58.0337 44.6382 58.053L45.9408 59.3242C45.9803 59.3628 46 59.4077 46 59.4591C46 59.5104 45.9803 59.5554 45.9408 59.5939C45.9013 59.6324 45.8544 59.6517 45.8001 59.6517C45.7459 59.6517 45.699 59.6324 45.6595 59.5939L44.6974 58.6549V60.8074C44.6974 60.862 44.6785 60.9077 44.6407 60.9445C44.6028 60.9815 44.5559 61 44.5 61Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1569_7305",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.8543 50.9518) scale(30.758 29.5382)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E6EBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D3DBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B9C6D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9AACBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#758EA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4B6B87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#345978"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaso2);
export default __webpack_public_path__ + "static/media/paso_2.c4e94243d92dc01142b7ffc054e98829.svg";
export { ForwardRef as ReactComponent };